import MenuRegisterContainer from './MenuRegisterContainer';
export default MenuRegisterContainer;
